import { types } from 'mobx-state-tree';

// Stores
import SharedStore from '../modules/shared/store';

export const sharedStore = SharedStore.create();

const RootStoreModel = types.model('RootStore', {
  sharedStore: types.optional(SharedStore, () => sharedStore),
});

const store = RootStoreModel.create();
export default store;
